function getKeyChain(keyChainId) {
  return this.keyChains.get(keyChainId);
}

module.exports = getKeyChain;
